/* t4188 protection guard.
 * Navidium "Shipping Protection" (product 10661469159729) must never be bought alone.
 * If every line in the cart is that product, remove the lines via /cart/change.js
 * and reload so the normal empty cart shows (cart page and drawer).
 * Runs: (a) on load when the server-rendered cart is protection-only
 *       (window.__protectionGuardServerOnly), (b) after any /cart/change|update|add|clear
 *       response (fetch or XHR), which covers the shopper removing the last real item.
 * Never touches carts that contain any other product. */
(function () {
  'use strict';
  var PID = 10661469159729;
  var rawFetch = window.fetch ? window.fetch.bind(window) : null;
  if (!rawFetch) return;
  var busy = false;
  var timer = null;
  var CART_URL = /\/cart\/(change|update|add|clear)(\.js|\.json)?(\?|$)/;

  function onlyProtection(cart) {
    return !!(cart && cart.items && cart.items.length > 0 &&
      cart.items.every(function (i) { return Number(i.product_id) === PID; }));
  }

  function mayReload() {
    // loop guard: at most 2 reloads per 15s in a tab
    try {
      var now = Date.now();
      var log = JSON.parse(sessionStorage.getItem('pg-reloads') || '[]')
        .filter(function (t) { return now - t < 15000; });
      if (log.length >= 2) return false;
      log.push(now);
      sessionStorage.setItem('pg-reloads', JSON.stringify(log));
    } catch (e) { /* storage blocked: allow a single reload */ }
    return true;
  }

  function clean() {
    if (busy) return Promise.resolve();
    busy = true;
    return rawFetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!onlyProtection(cart)) { busy = false; return; }
        var chain = Promise.resolve();
        cart.items.forEach(function (i) {
          chain = chain.then(function () {
            return rawFetch('/cart/change.js', {
              method: 'POST',
              credentials: 'same-origin',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ id: i.key, quantity: 0 })
            });
          });
        });
        return chain.then(function () {
          busy = false;
          if (mayReload()) window.location.reload();
        });
      })
      .catch(function () { busy = false; });
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(clean, 400); // let a paired add of the real item land first
  }

  // fetch hook
  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = rawFetch.apply(window, arguments);
    if (CART_URL.test(url)) p.then(schedule, function () {});
    return p;
  };

  // XHR hook (jQuery based app scripts)
  var xo = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__pgUrl = String(url || '');
    return xo.apply(this, arguments);
  };
  var xs = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    if (CART_URL.test(this.__pgUrl || '')) this.addEventListener('loadend', schedule);
    return xs.apply(this, arguments);
  };

  if (window.__protectionGuardServerOnly) clean();

  if (typeof module !== 'undefined') module.exports = { clean: clean, onlyProtection: onlyProtection, schedule: schedule };
})();
